import { Divider, Typography, Row, Col, Card, Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { QRCodeCanvas } from 'qrcode.react';
import moment from 'moment';
import './QuotationPreview.css';

const { Title, Text } = Typography;


const branchAddresses = {
  1: {
    name: "Keaes Academics (Ekamai)",
    address: [
      "982/22 Gateway Ekamai,",
      "4th Fl. Sukhumvit Rd, Phra Khanong,",
      "Khlong Toei, Bangkok 10110"
    ],
    tel: "Tel: 02-108-2922",
  },
  2: {
    name: "Keaes Academics (Ramkhamhaeng)",
    address: [
      "61 Marketplace, 3rd Fl.,",
      "Ramkhamhaeng Rd, Saphan Sung,",
      "Bangkok 10240"
    ],
    tel: "Tel: 02-729-5826",
  }
};


const formatNumber = (num) =>
  new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2 }).format(num || 0);

const QuotationPreview = ({ data, overrideCreatedAt }) => {
  if (!data) return null;

  // Print function
  const handlePrint = () => {
    window.print();
  };

  const {
    quotation_no,
    items = [],
    student_name,
    address,
    phone,
    subtotal,
    discount,
    vat,
    total_amount,
    created_by_firstname,
    created_by_lastname,
    unique_id,
    expiration_days = 3 
  } = data;

  // Calculate expiration date based on expiration_days
  const createdAtToUse = overrideCreatedAt || data.created_at;

  const calculateExpirationDate = () => {
    if (!createdAtToUse) return moment().add(data.expiration_days || 3, 'days').format('DD MMM YYYY');
    return moment(createdAtToUse).add(data.expiration_days || 3, 'days').format('DD MMM YYYY');
  };

  // Generate QR code data
  const qrCodeData = unique_id || quotation_no || `QO-${moment().format('YYYYMMDDHHmm')}`;

  // Calculate totals for summary
  const totalAfterDiscount = subtotal - discount;

  // Helper function to get expiration text
  const getExpirationText = () => {
    const days = expiration_days;
    if (days === 1) return '1 day';
    if (days < 7) return `${days} days`;
    if (days === 7) return '1 week';
    if (days === 15) return '15 days';
    if (days === 30) return '1 month';
    return `${days} days`;
  };
  const branchInfo = branchAddresses[data.branch_id] || {
  name: "Keaes Academics",
  address: "-",
  tel: "-",
};


  return (
    <div id="quotation-preview-content" style={{ 
      width: '100%',
      padding: '0',
      margin: '0',
      backgroundColor: 'white',
      fontFamily: '"Sarabun", Arial, sans-serif'
    }}>
      {/* Header section with logo and company info - Compact */}
      <div style={{ 
        display: 'flex', 
        marginBottom: '12px',
        alignItems: 'flex-start'
      }}>
        {/* Left side - Logo */}
        <div style={{ 
          width: '70px', 
          height: '70px',
          marginRight: '16px'
        }}>
          <img 
            src="/images/keaes150.png" 
            alt="KEAES" 
            style={{ 
              width: '120%',
              height: 'auto'
            }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
        
        {/* Middle - Company info */}
        <div style={{ flex: 1, paddingTop: '2px' }}>
         <h3 style={{
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '6px',
            marginTop: 0,
            color: '#333',
            textAlign: 'left',
            marginLeft: '24px'
          }}>
            {branchInfo.name}
          </h3>
          <p style={{ fontSize: '14px', margin: '2px 0', lineHeight: '1.3', color: '#4a4a4a', textAlign: 'left', marginLeft: '24px' }}>
            {branchInfo.address.map((line, idx) => (
            <p
              key={idx}
              style={{
                fontSize: '14px',
                margin: '2px 0',
                lineHeight: '1.3',
                color: '#4a4a4a',
                textAlign: 'left',
                marginLeft: '24px'
              }}
            >
              {line}
            </p>
          ))}

          </p>
          <p style={{ fontSize: '14px', margin: '2px 0', lineHeight: '1.3', color: '#4a4a4a', textAlign: 'left', marginLeft: '24px' }}>
            {branchInfo.tel}
          </p>
          <p style={{ fontSize: '14px', margin: '2px 0', lineHeight: '1.3', color: '#4a4a4a', textAlign: 'left', marginLeft: '24px' }}>
            Email: contact@keaes.com
          </p>
        </div>
        
        {/* Right side - Quotation box */}
        <div style={{ 
          background: 'rgba(200, 200, 200, 0.3)', 
          padding: '12px', 
          color: '#333',
          borderRadius: '6px',
          width: '350px',
          textAlign: 'center',
          marginLeft: 'auto',
        }}>
          <h2 style={{ 
            color: '#333', 
            fontSize: '20px', 
            margin: '0 0 12px 0',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            QUOTATION
          </h2>
          <div style={{ fontSize: '14px', margin: '4px 0', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 'bold', color: '#333' }}>No:</span>
            <span style={{ color: '#333', marginLeft: 6 }}>{quotation_no}</span>
          </div>
          <div style={{ fontSize: '14px', margin: '4px 0', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 'bold', color: '#333' }}>Date:</span>
            <span style={{ color: '#333', marginLeft: 6 }}>{moment(createdAtToUse).format('DD MMM YYYY')}</span>
          </div>
          <div style={{ fontSize: '14px', margin: '4px 0', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 'bold', color: '#333' }}>Valid for:</span>
            <span style={{ color: '#d32f2f', fontWeight: 'bold', marginLeft: 6 }}>
              {getExpirationText()}
            </span>
          </div>
          <div style={{ fontSize: '14px', margin: '4px 0', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 'bold', color: '#333' }}>Expires:</span>
            <span style={{ color: '#d32f2f', fontWeight: 'bold', marginLeft: 6 }}>
              {calculateExpirationDate()}
            </span>
          </div>
        </div>
      </div>

      {/* Customer Information - Compact */}
      <div style={{ marginBottom: '12px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 'bold', 
          marginBottom: '10px',
          color: '#333',
        }}>Customer Information</h3>
        <div style={{
          backgroundColor: '#f9f9f9',
          border: '1px solid #ccc',
          borderRadius: '6px',
          padding: '12px 16px'
        }}>
          <p style={{ fontSize: '14px', margin: '5px 0', color: '#333' }}>
            <strong>Name:</strong> {student_name || '-'}
          </p>
          <p style={{ fontSize: '14px', margin: '5px 0', color: '#333' }}>
            <strong>Address:</strong> {address || '-'}
          </p>
          <p style={{ fontSize: '14px', margin: '5px 0', color: '#333' }}>
            <strong>Phone:</strong> {phone || '-'}
          </p>
        </div>
      </div>

      <hr style={{ 
        border: 'none', 
        height: '1px', 
        backgroundColor: '#ccc', 
        margin: '12px 0'
      }} />

      {/* Quotation Items Table */}
      <div style={{ marginTop: '12px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 'bold', 
          marginBottom: '10px',
          color: '#333',
        }}>Quotation Items</h3>
        
        <div style={{ 
          width: '100%', 
          fontSize: '14px',
          border: '1px solid #ccc',
          borderRadius: '6px',
          overflow: 'hidden'
        }}>
          {/* Header Row */}
          <div style={{
            background: 'rgba(200, 200, 200, 0.3)', 
            padding: '8px 12px',
            borderBottom: '1px solid #495057',
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333',
            borderRadius: '4px 4px 0 0',
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '5%', textAlign: 'center' }}>#</div>
              <div style={{ width: '45%', paddingLeft: '8px' }}>Description</div>
              <div style={{ width: '10%', textAlign: 'center' }}>Quantity</div>
              <div style={{ width: '20%', textAlign: 'right' }}>Unit Price</div>
              <div style={{ width: '20%', textAlign: 'right' }}>Total</div>
            </div>
          </div>

          {/* Table Body as Card Rows */}
          <div>
            {items.map((item, index) => (
              <div 
                key={index} 
                style={{ 
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                  padding: '8px 12px',
                  borderBottom: index === items.length - 1 ? 'none' : '1px solid #f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  minHeight: '32px'
                }}
              >
                <div style={{ width: '5%', textAlign: 'center', color: '#333', fontWeight: 'bold', fontSize: '14px' }}>{index + 1}</div>
                <div style={{ width: '45%', paddingLeft: '8px', color: '#333', fontWeight: '500', fontSize: '14px' }}>{item.description}</div>
                <div style={{ width: '10%', textAlign: 'center', color: '#333', fontSize: '14px' }}>{item.quantity}</div>
                <div style={{ width: '20%', textAlign: 'right', color: '#333', fontSize: '14px' }}>฿{formatNumber(item.unit_price)}</div>
                <div style={{ width: '20%', textAlign: 'right', color: '#333', fontWeight: 'bold', fontSize: '14px' }}>฿{formatNumber(item.amount)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Summary Information - Compact */}
      <div style={{ 
        fontSize: 14,
        border: '1px solid #6c757d',
        padding: 12,
        background: 'linear-gradient(135deg, #f9f9f9 0%, #f0f0f0 100%)',
        borderRadius: 6,
        width: 320,
        marginLeft: 'auto',
        marginTop: '16px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', color: '#333' }}>
          <span>Sub Total:</span>
          <span>฿{formatNumber(subtotal)}</span>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
          <span style={{ color: '#333' }}>Discount:</span>
          <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>-฿{formatNumber(discount)}</span>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', color: '#333' }}>
          <span>Total after discount:</span>
          <span>฿{formatNumber(totalAfterDiscount)}</span>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', color: '#333' }}>
          <span>VAT 7%:</span>
          <span>฿{formatNumber(vat)}</span>
        </div>
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          margin: '8px 0 6px 0',
          fontWeight: 'bold',
          fontSize: '16px',
          borderTop: '1px solid #6c757d',
          paddingTop: '6px',
          color: '#333'
        }}>
          <span>Grand Total:</span>
          <span>฿{formatNumber(total_amount)}</span>
        </div>
      </div>

      {/* Remark Section - Compact */}
      {data.remark && (
        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: 'bold', 
            marginBottom: '10px',
            color: '#333',
          }}>Remark</h3>
          <div style={{
            backgroundColor: '#f0f8ff',
            border: '1px solid #bae7ff',
            borderRadius: '6px',
            padding: '12px 16px'
          }}>
            <p style={{ 
              fontSize: '14px', 
              margin: '0', 
              color: '#0050b3',
              fontStyle: 'italic',
              fontWeight: '500'
            }}>
              {data.remark}
            </p>
          </div>
        </div>
      )}

      {/* Payment Information - Compact */}
      <div style={{ marginTop: '16px', marginBottom: '16px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 'bold', 
          marginBottom: '10px',
          color: '#333',
        }}>Payment Information</h3>
        <div style={{
          backgroundColor: '#f9f9f9',
          border: '1px solid #ccc',
          borderRadius: '6px',
          padding: '12px 16px'
        }}>
          <div style={{ display: 'flex', gap: '32px' }}>
            {[1, 2].map(i => {
              const name = data[`bank${i}_name`];
              if (!name) return null;

              return (
                <div key={i} style={{ flex: 1, fontSize: '14px', lineHeight: '1.5', color: '#333' }}>
                  <div style={{ marginBottom: '4px' }}>
                    <strong>Bank:</strong> {data[`bank${i}_name`]}
                  </div>
                  {data[`bank${i}_bank_branch`] && (
                    <div style={{ marginBottom: '4px' }}>
                      <strong>Branch:</strong> {data[`bank${i}_bank_branch`]}
                    </div>
                  )}
                  <div style={{ marginBottom: '4px' }}>
                    <strong>Account Name:</strong> {data[`bank${i}_account_name`]}
                  </div>
                  <div>
                    <strong>Account Number:</strong> {data[`bank${i}_account_number`]}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Terms and Conditions - Compact */}
      <div style={{ marginTop: '16px', marginBottom: '16px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 'bold', 
          marginBottom: '10px',
          color: '#333',
        }}>Terms and Conditions</h3>
        <div style={{
          backgroundColor: '#f9f9f9',
          border: '1px solid #ccc',
          borderRadius: '6px',
          padding: '12px 16px'
        }}>
          <p style={{ fontSize: '14px', margin: '0', color: '#333', lineHeight: '1.5' }}>
            All payment cannot be refunded.
          </p>
        </div>
      </div>

      {/* QR Code, Signature, and Print Info Footer - Compact */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-end',
        marginTop: '16px',
        marginBottom: '12px',
        padding: '12px 0',
        borderTop: '1px solid #ccc'
      }}>
        {/* QR Code Section */}
        <div style={{ 
          width: '25%', 
          textAlign: 'center'
        }}>
          <QRCodeCanvas
            value={qrCodeData}
            size={50}
            level="M"
          />
          <div style={{ 
            fontSize: '9px', 
            marginTop: '4px', 
            color: '#495057',
            fontFamily: 'monospace',
            wordBreak: 'break-all',
            fontWeight: 'bold'
          }}>
            QUOTATION
          </div>
        </div>
        
        {/* Signature Section */}
        <div style={{ 
          width: '50%', 
          textAlign: 'center',
          padding: '0 16px'
        }}>
          <div>
            <div style={{ 
              fontSize: '14px', 
              fontWeight: 'bold', 
              marginBottom: '60px',
              color: '#333'
            }}>
              Quoted by
            </div>
            <div style={{ 
              borderTop: '1px solid #6c757d', 
              width: '240px', 
              margin: '0 auto',
              paddingTop: '6px',
              fontSize: '14px',
              color: '#333'
            }}>
              {created_by_firstname && created_by_lastname ? (
                <div style={{ fontWeight: '500' }}>
                  {created_by_firstname} {created_by_lastname}
                </div>
              ) : (
                <div style={{ color: '#495057' }}>
                  Authorized Staff
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* Print Info Section */}
        <div style={{ 
          width: '25%', 
          textAlign: 'right', 
          fontSize: '12px', 
          color: '#495057'
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
            Printed On:
          </div>
          <div style={{ marginBottom: '2px' }}>
            {moment().format('DD MMM YYYY')}
          </div>
          <div>
            {moment().format('HH:mm:ss')}
          </div>
        </div>
      </div>
      
      {/* Print Button - Compact */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center',
        marginTop: '12px',
        '@media print': {
          display: 'none'
        }
      }} className="no-print">
        <button 
          onClick={handlePrint}
          style={{
            padding: '8px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: '1px solid #495057',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            transition: 'all 0.3s ease',
            textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#495057';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#6c757d';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          <span style={{ fontSize: '14px' }}>🖨️</span>
          Print Quotation
        </button>
      </div>
    </div>
  );
};

export default QuotationPreview;